var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"refresh-button"},[_c('v-btn',{staticClass:"secondary-btn pl-1 mr-3",on:{"click":function($event){return _vm.RefreshTools()}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-refresh")]),_vm._v(" Refresh ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }